import { DataObject } from '../../../../../../models/data-object.models';

export interface DetailRequestModel {
  method: string;
  payload: DataObject;
  order: number;
}
const sortByOrder = (detail: DetailRequestModel, detailNext: DetailRequestModel) => detail.order - detailNext.order;

export abstract class AbstractRequestClass {
  protected payloads: DetailRequestModel[] = [];
  protected payload: DataObject = {};
  protected edpMethod: string;

  public abstract getMultiEndPoints(): DetailRequestModel[] | null;
  public abstract getMappingRequest(): DataObject;

  constructor(params: DataObject, edpMethod: string) {
    this.edpMethod = edpMethod;
    this.init(params);
  }

  protected init(params: DataObject) {
    this.setParamsPayload(params);
    this.setPayload();
  }

  protected setParamsPayload(params: DataObject): void {
    const mapRequest = this.getMappingRequest();
    Object.keys(params)
      .filter(key => mapRequest[key] != null)
      .forEach((key: string) => {
        const param = mapRequest[key];
        this.payload[param] = params[key];
      });
  }

  private setPayload(): void {
    const multiEndPoints = this.getMultiEndPoints();
    this.payloads = !!multiEndPoints
      ? this.getMultiPayload(multiEndPoints)
      : [this.getSimplePayload(this.edpMethod, this.payload, 0)];
  }

  private getMultiPayload(multiEndPoints: DetailRequestModel[]): DetailRequestModel[] {
    return multiEndPoints.sort(sortByOrder);
  }

  private getSimplePayload(edpMethod: string, payload: DataObject, order: number): DetailRequestModel {
    return {
      method: edpMethod,
      payload,
      order,
    };
  }
}
